import { lazy } from 'react';

import { Route, Routes } from 'react-router-dom';

import { useFeatureFlag } from '@packages/platform/feature-flags/use-feature-flag';
import { ProtectedRoute } from 'ae-components/protected-route/protected-route';

import { AGENT_SETTINGS_READ_CAPABILITY } from './components/agent-settings/agent-settings-layout/agent-settings-layout';
import { AgentSettingsRoutes } from './routes/agent-settings.routes';

const AgentsPage = lazy(() => import('./pages/agents.page'));
const AgentsPageV2 = lazy(() => import('./pages/agents.page-v2'));

// [TODO] - AGENT-1356 Once we add customer facing settings routes we will need to remove the protected route wrapper

export const AgentsRoutes = () => {
  const [tableV2FF] = useFeatureFlag('AGENTS_TABLE_V2');

  return (
    <Routes>
      {tableV2FF ? (
        <Route index element={<AgentsPageV2 />} />
      ) : (
        <Route index element={<AgentsPage />} />
      )}
      <Route
        element={
          <ProtectedRoute
            capabilityIds={[AGENT_SETTINGS_READ_CAPABILITY]}
            legacyCapabilities={{ canViewAgentSettings: true }}
          />
        }
      >
        <Route path="settings/*" element={<AgentSettingsRoutes />} />
      </Route>
    </Routes>
  );
};
